import { makeStyles, Theme } from '@freighthub/silhouette-core'
import { Address } from 'features/Directory'
import moment from 'moment'
import { FC } from 'react'
import { formatNumber } from 'service/NumberFormatter'
import { DateFormatMoment } from 'utils/date'
import { useI18n } from 'utils/localisation'

import { msToDays } from '../../formatDate'
import { arrivalDate, departureDate, Route } from '../QuoteSheetOption'
import { Description } from './Description'
import { LCLDescriptions } from './LCLDescriptions'
import { TransportProps } from './QuoteTransportPlan'
import { SailingDescriptions } from './SailingDescriptions'
import { TransportTime } from './TransportTime'

export const useDescriptionStyles = makeStyles<Theme>(() => ({
  descriptions: {
    flexGrow: 1,
  },
}))

export const Descriptions: FC<TransportProps> = (props) => {
  const {
    option,
    quoteSheet: { request },
  } = props
  const { translate } = useI18n()
  const { ignorePreCarriageDuration } = request
  const classes = useDescriptionStyles()

  if (request.type === 'lcl') {
    return <LCLDescriptions {...props} />
  }
  const sailing = option.routeQuotes.mainQuote.route.routeSchedule
  const hasPreRun = option.routeQuotes.preQuote && option.routeQuotes.preQuote.route
  const hasPostRun = option.routeQuotes.postQuote && option.routeQuotes.postQuote.route
  const origin = request.journey.origin as Address
  return (
    <div className={classes.descriptions}>
      {hasPreRun && (
        <div>
          <Description
            time={
              <TransportTime
                // @ts-expect-error TS(2322) FIXME: Type 'string | false' is not assignable to type 's... Remove this comment to see the full error message
                preLabel={!ignorePreCarriageDuration && translate('quote_sheet-option-transport_plan-estimated_pickup')}
                // @ts-expect-error TS(2322) FIXME: Type 'string | false' is not assignable to type 's... Remove this comment to see the full error message
                time={!ignorePreCarriageDuration && moment(departureDate(option)).format(DateFormatMoment.DATE)}
              />
            }
            label={translate('quote_sheet-option-transport_plan-origin')}
            text={origin.city || origin.country}
          />
          <Description
            time={
              <TransportTime
                // @ts-expect-error TS(2322) FIXME: Type 'string | false' is not assignable to type 's... Remove this comment to see the full error message
                time={
                  !ignorePreCarriageDuration &&
                  translate('quote_sheet-option-transport_plan-pre_run-estimate', {
                    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
                    days: msToDays(option.routeQuotes.preQuote.route.duration),
                  })
                }
              />
            }
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            label={`${option.routeQuotes.preQuote.mode} ${translate(
              'quote_sheet-option-transport_plan-pre_run-pre_carriage'
            )}`}
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            text={distance(option.routeQuotes.preQuote.route)}
          />
        </div>
      )}

      {sailing && <SailingDescriptions sailing={sailing} />}

      {hasPostRun && ( // POST RUN / On-carriage
        <div>
          <Description
            time={<span />}
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            label={`${option.routeQuotes.postQuote.mode} ${translate(
              'quote_sheet-option-transport_plan-post_run-on_carriage'
            )}`}
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            text={distance(option.routeQuotes.postQuote.route)}
            invertBg
          />
          <Description
            time={
              <TransportTime
                preLabel={translate('quote_sheet-option-transport_plan-estimated_delivery')}
                time={moment(arrivalDate(option)).format(DateFormatMoment.DATE)}
                postLabel={translate('quote_sheet-option-transport_plan-post_run-estimate_adjust')}
              />
            }
            label={translate('quote_sheet-option-transport_plan-destination')}
            text={(request.journey.destination as Address).city}
            // @ts-expect-error TS(2322) FIXME: Type 'string | false' is not assignable to type 's... Remove this comment to see the full error message
            note={option.mode === 'sea' && translate('quote_sheet-option-transport_plan-destination_note')}
            invertBg
          />
        </div>
      )}
    </div>
  )
}

const distance = (run: Route) => {
  if (run.distance == null) return ''
  return `${formatNumber(run.distance / 1000, 2)} km`
}
